import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthComponent } from "../auth/auth.component";
import { ElofizetoCegService } from '../../../services/elofizeto-ceg.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Component({
    selector: 'rendelo-menu',
    imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    AuthComponent
],
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
    private elofizetoCegService = inject(ElofizetoCegService);
    private router = inject(Router);
    private authService = inject(AuthService);

    // Check if user is authenticated
    readonly isAuthenticated = toSignal(this.authService.isAuthenticated$, { initialValue: false });

    // Reactive signal to check if company is selected
    readonly hasSelectedCeg = computed(() =>
        this.elofizetoCegService.selectedCegGuid() !== null
    );

    // Check if currently on select-ceg page
    readonly isOnSelectCegPage = toSignal(
        this.router.events.pipe(
            map(() => this.router.url === '/select-ceg')
        ),
        { initialValue: this.router.url === '/select-ceg' }
    );

    // Navigate to company selection page
    navigateToCegSelection(): void {
        this.router.navigate(['/select-ceg']);
    }
}
